'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchImage = fetchImage;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchImage(src) {
  return _q2.default.promise(function (resolve, reject) {
    var img = new Image();
    img.onerror = reject;
    img.onload = resolve;
    img.src = src;
  });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/core/Image.js
// module id = 233
// module chunks = 0 1